document.addEventListener("DOMContentLoaded", ()=>{
    const copyrightYear = document.getElementById('copyrightYear')

    if(copyrightYear) {
        const currentYear = new Date().getFullYear()
        if(copyrightYear.innerText != currentYear) {
            copyrightYear.innerHTML += '&ndash;' + currentYear.toString()
        }
    }
})